import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import CategoryFilterBody from "./bodies/CategoryFilterBody.vue";
export default {
  name: "CategoryFilter",
  components: {
    FilterItem,
    CategoryFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    categories: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    }
  },
  computed: {
    getCategoryTitle() {
      let joinedContents = this.categories.selected.map(el => el?.category).join(", ");
      joinedContents = joinedContents.length > 0 ? joinedContents : 'All Categories';
      return truncateString(joinedContents, 16);
    },
    getCategorySelectedTitle() {
      const joined = this.categories.selected.map(el => el?.category).join(", ");
      return joined.length > 0 ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handleCategorySearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.categories.searching = false;
      }
      this.categories.listSearch(value, ['category']);
    },
    handleClear() {
      this.categories.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.categories.restoreSearch();
    },
    handleSelect(val) {
      this.categories.select(val, 'category');
    },
    handleSelectOnly(val) {
      this.categories.selectOnly(val, 'category');
    },
    handleDeselect(val) {
      this.categories.deselect(val, 'category');
      if (this.categories?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    handleClearAll() {
      this.categories.clear();
      this.$emit('cleared');
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.categories.clearDraft();
    },
    onHidden() {
      this.categories.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.categoryFilterItem, initializer, callback);
    }
  }
};